import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_95: FaireProductEntity = {
  token: "starter_collection_95",
  type: "product",
  name: "Piano Cocktail Glasses Bluenote",
  brandName: "Sophie Lou Jacobsen",
  imageUrl:
    "https://cdn.faire.com/fastly/0204b78f9035ee9d8eab93f3b82f013fd3aeca9b26b01aee39f66b1b63045f29.jpeg?bg-color=FFFFFF&canvas=100p%2C100p%2Coffset-x50p%2Coffset-y50p&format=jpg&precrop=98.38p%2C65.61p%2Cx1.56p%2Cy15.8p&width=720",
  priceDollars: 95,
  msrpDollars: 190,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
